import { journeyPostJson } from '../utils/journeyApi';
import { v4 as uuidv4 } from 'uuid';
import { localStorageGetItem, localStorageSetItem } from '../utils/storage';

function getAnonymousId() {
  const ajsAnonymousId = localStorageGetItem('ajs_anonymous_id');

  if (!ajsAnonymousId) {
    const newUUID = uuidv4();
    localStorageSetItem('ajs_anonymous_id', newUUID);
    return newUUID;
  }

  try {
    const val = JSON.parse(ajsAnonymousId);
    return val;
  } catch (e) {
    return ajsAnonymousId;
  }
}

function apiSegmentIdentifyAnonymous(traits = {}) {
  const apiUrl = `/api/segment/identify`;

  return journeyPostJson(apiUrl, {
    anonymous_id: getAnonymousId(),
    traits: traits,
  });
}

function apiSegmentTrackAnonymous(event_name, properties = {}) {
  const apiUrl = `/api/segment/track`;

  return journeyPostJson(apiUrl, {
    anonymous_id: getAnonymousId(),
    event_name: event_name,
    properties: properties,
  });
}

function apiSegmentWaitlistIdentify(email, traits = {}) {
  const apiUrl = `/api/segment/waitlist-identify`;

  return journeyPostJson(apiUrl, {
    anonymous_id: getAnonymousId(),
    traits: {
      email: email,
      ...traits,
    },
  });
}

function triggerSegmentEvent(event_name, properties = {}) {
  window.analytics && window.analytics.track(event_name, properties);
}

export {
  getAnonymousId,
  apiSegmentIdentifyAnonymous,
  apiSegmentTrackAnonymous,
  apiSegmentWaitlistIdentify,
  triggerSegmentEvent,
};
